import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { clearQueryStale, selectIsQueryStale } from './staleManager';
import { defaultSerializeQueryArgs } from '@reduxjs/toolkit/query';


export const useQueryStale = ({query, endpointName, queryArgs}) => {

    const dispatch = useDispatch();

    const cacheKey = useMemo(() =>
        defaultSerializeQueryArgs({endpointName, queryArgs}),
    [endpointName, queryArgs]);

    const isStale = useSelector(state =>
        selectIsQueryStale(state, cacheKey)
    );

    /**
     * Есть локальный кэш,
     * но он stale → обновляем.
     */
    useEffect(() => {

        if (
            !isStale ||
            !query.data ||
            query.isFetching
        ) {
            return;
        }

        query.refetch();

    }, [isStale, query.data, query.isFetching, query.refetch]);

    /**
     * После успешного refetch
     * снимаем stale.
     */
    useEffect(() => {

        if (
            !isStale ||
            query.isFetching ||
            !query.isSuccess
        ) {
            return;
        }

        dispatch(
            clearQueryStale(cacheKey)
        );

    }, [isStale, query.isFetching, query.isSuccess, cacheKey, dispatch]);

};